module.exports = __webpack_public_path__ + "img/delete.93b29abe.svg";